import type { StatusCodes } from "http-status-codes";
import type { HttpMethod } from "openapi-typescript-helpers";

export interface FailedRequestInfo {
  url: string;
  method: HttpMethod;
  status: StatusCodes;
  args?: string;
}

export class UnauthorizedException extends Error {
  constructor(message?: string) {
    super(message);
    this.name = "UnauthorizedException";
  }
}

export class ForbiddenException extends Error {
  constructor(message?: string) {
    super(message);
    this.name = "ForbiddenException";
  }
}

export class MutationException extends Error {
  requestInfo: FailedRequestInfo;

  constructor(requestInfo: FailedRequestInfo, message?: string) {
    super(message);
    this.name = "MutationException";
    this.requestInfo = requestInfo;
  }
}
